import { render } from "./AddRoverPage.vue?vue&type=template&id=809c5b56"
import script from "./AddRoverPage.vue?vue&type=script&lang=js"
export * from "./AddRoverPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__